import { AppState } from 'modules/types'

export const getBannerTitle = (state: AppState) => state.banner.title
export const getBannerText = (state: AppState) => state.banner.text
export const getBannerType = (state: AppState) => state.banner.bannerType
